<template>
  <b-overlay :show="loading">
    <div class="d-flex justify-content-between p-3">
      <b-form inline @submit.prevent="searchMessages">
        <b-form-input
          v-model="form.email"
          id="form-search"
          class="mb-2 mr-sm-2 mb-sm-0"
          placeholder="Enter email"
        ></b-form-input>
        <b-button variant="primary" type="submit">Search</b-button>
      </b-form>
      <span class="mt-2">Total messages: {{form.total}}</span>
      <b-pagination class="mb-0"
        v-model="form.page"
        :total-rows="form.total"
        :per-page="form.limit"
        @page-click="changePage"
      ></b-pagination>
    </div>
    <b-table hover :items="messages" :fields="fields">
      <template #cell(id)="data">
        <p style="width: 64px;">{{ data.item.id }}</p>
      </template>
      <template #cell(email)="data">
        <div style="width: 250px;">
          <p>
            Sender: {{ data.item.name }} &lt;{{ data.item.email }}&gt;
            <br>
            Company: {{ data.item.company }} <span v-if="data.item.company_email">&lt;{{ data.item.company_email }}&gt;</span>
          </p>
          <p>Sent: {{ data.item.ts_sent }}</p>
        </div>
      </template>
      <template #cell(message)="data">
        <p>
          Mail report: {{ data.item.mail_report }}
          <br>
          Attachment: 
          <a v-if="data.item.attachment" :href="data.item.attachment" target="_blank">{{getFilename(data.item.attachment)}}</a>
          <span v-else>No attachment</span>
        </p>
        <div style="white-space: pre-wrap;">{{ data.item.message }}</div>
      </template>
    </b-table>
  </b-overlay>
</template>

<script>
import api from '@/api'

export default {
  data: () => ({
    loading: false,
    form: {
      email: '',
      page: 1,
      limit: 10,
      total: 0
    },
    fields: [
      {
        key: 'id',
        label: 'ID'
      },
      {
        key: 'email',
        label: 'Sender'
      },
      {
        key: 'message',
        label: 'Message'
      },
    ],
    messages: []
  }),
  mounted () {
    this.searchMessages()
  },
  methods: {
    searchMessages: async function () {
      this.loading = true
      let result = await api.admin.message.search(this.form.email, this.form.page, this.form.limit)
      this.messages = result.messages
      this.form.total = result.total
      this.loading = false
    },
    changePage: function (e, page) {
      if (page !== this.form.page) {
        this.form.page = page
        this.searchMessages()
      }
    },
    getFilename: function (path) {
      return path.split('/').pop()
    }
  }
}
</script>

<style scoped>
</style>
